export default __webpack_public_path__ + "static/media/gallery_05.00fb2394.jpg";